var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { baseFetch } from "../../utility/api";
import { handleResponse } from "../../utility/api/handleResponse";
/**
 * Gets Accounts Domain from arguments needed to construct a fetch
 *
 * @param args Arguments used to construct the headers and the baseFetch
 * @returns Returns AccountsDomain from fetch response
 *
 * @example
 * ```ts
 * accounts.api.get({
 *   access_token: "at-1234",
 *   allyUserRole: {
 *   auto: true,
 *   bank: true,
 *   creditcard: true,
 *   guest: false,
 *   investment: true,
 *   mortgage: true,
 *   wealth: true,
 *   },
 *   environment: "ios-dev",
 *   guid: "guid-1234",
 *   })
 * ```
 */
export function get(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { guid, allyUserRole, tpn, environment } = args;
        const id = guid || tpn; // guid can be an empty string
        const url = `/acs/v2/customers/${id}/accounts`;
        const headers = Object.assign(Object.assign({ Authorization: `Bearer ${args.access_token}` }, (allyUserRole && { allyuserrole: JSON.stringify(allyUserRole) })), (tpn && { AutoThirdPartyNumber: tpn }));
        const fetcher = baseFetch({ environment });
        const response = yield fetcher(url, {
            headers,
        });
        const json = yield handleResponse(response);
        return json;
    });
}
//# sourceMappingURL=index.js.map